/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import React from 'react';
import './static/fonts/fonts.css';
import './src/styles/STtheme/_var.css';
import './src/styles/STtheme/global.less';
import { testHeaderFooterPricingMenuItems } from './src/utils/intellimize';
import AnnouncementBarContext from 'utils/AnnouncementBarContext';
import { HeaderMenuContextOverlay } from './src/utils/HeaderMenuContext';

const onPreRouteUpdate = () => {
  if (typeof window === 'object' && window.intellimize) {
    intellimize.push(['activate']);
  }
};

const onInitialClientRender = () => {
  testHeaderFooterPricingMenuItems();
  window.history.pushState({ prevUrl: document.referrer || '' }, null);
  Object.defineProperty(document, 'referrer', {
    get: function() {
      return window.history.state?.prevUrl;
    },
  });
};

const onRouteUpdate = ({ location, prevLocation }) => {
  if (prevLocation) {
    window.history.pushState({ prevUrl: prevLocation.href }, null);
  }

  if (window.om70344_62468) {
    window.om70344_62468.reset();
  }
};

const wrapPageElement = ({ element, props }) => {
  return (
    <AnnouncementBarContext.Provider
      value={{ hideAnnouncementBar: props?.data?.contentfulPage?.seo?.hideAnnouncementBar }}
    >
      <HeaderMenuContextOverlay {...props}>{element}</HeaderMenuContextOverlay>
    </AnnouncementBarContext.Provider>
  );
};

export { onInitialClientRender, onPreRouteUpdate, onRouteUpdate, wrapPageElement };
